<template>
  <div class="content additional-data print mt-4 text-left hidden">
    <div class="list-single-main-item fl-wrap">
      <div
        class="list-single-main-item-title fl-wrap"
        :class="{ 'mb-0': !mapSelected }"
      >
        <h3 v-if="mapSelected">{{ $t('ui_pdfHeader') }}</h3>
        <h3 v-else>
          {{ $t('ui_pdfPrinted') }}: {{ currentDate | toDateTime }}
        </h3>
      </div>
      <div class="mb-4 d-flex w-100 justify-content-between" v-if="mapSelected">
        <div class="" v-if="mapSelected.Locality || mapSelected.Latitude">
          <a
            class="map-item scroll-top-map pointer mr-2"
            v-if="mapSelected.Locality"
          >
            <k-icon name="fa-map-marker-alt"></k-icon>
            <span class="adat_hely">
              {{ mapSelected.Locality }}
            </span>
          </a>
          <a
            class="map-item scroll-top-map pointer"
            v-if="mapSelected.Latitude"
          >
            <k-icon name="fa-location-arrow"></k-icon>
            <span class="adat_hely">
              {{ mapSelected.Latitude }}, {{ mapSelected.Longitude }}
            </span>
          </a>
        </div>
        <div class="" :class="{ 'text-right': mapSelected.Locality }">
          <k-icon name="fa-calendar-alt"></k-icon>
          <span class="adat_hely">
            {{ mapSelected.Created | toShortDate }}
          </span>
        </div>
      </div>
      <div v-if="mapSelected" class="d-inline-flex ikonok">
        <bejegyzes-ikonok
          class="d-flex flex-wrap justify-content-start flex-row "
          :bejegyzesIcons="mapSelected.Types"
          :iconText="true"
        ></bejegyzes-ikonok>
        <bejegyzes-ikonok
          :bejegyzesIcons="[mapSelected.Size]"
          :iconText="true"
          class=""
        ></bejegyzes-ikonok>
      </div>
      <div class="list-author-widget-contacts" v-if="mapSelected">
        <ul>
          <li v-if="mapSelected && pontosCim">
            <span
              ><i class="fa fa-map-marker"></i>
              {{ $t('ui_pdfAddress') }} :</span
            >
            <a href="javascript:;">{{ pontosCim }}</a>
          </li>
          <!-- <li v-if="mapSelected && mapSelected.Latitude">
            <span
              ><i class="fas fa-map-marked-alt"></i>
              {{ $t('ui_pdfKoordinata') }} :</span
            >
            <a href="javascript:;"
              >{{ mapSelected.Latitude }}, {{ mapSelected.Longitude }}</a
            >
          </li> -->
          <li>
            <span
              ><i class="fas fa-clock"></i> {{ $t('ui_pdfPrinted') }} :</span
            >
            <a href="javascript:;">{{ currentDate | toDateTime }}</a>
          </li>
        </ul>
      </div>
      <div class="list-widget-social">
        <div class="row text-center">
          <div class="col-6" v-if="wazeLink">
            <div v-html="wazeLink.qr"></div>
            <div>
              <a target="_blank" :href="wazeLink.url">
                {{ $t('ui_pdfOpenWaze') }}
              </a>
            </div>
          </div>
          <div class="col-6" v-if="googleLink">
            <div v-html="googleLink.qr"></div>
            <div>
              <a target="_blank" :href="googleLink.url">
                {{ $t('ui_pdfOpenGoogle') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import qrcode from 'qrcode-generator';
import { apiService } from '../../main';
export default {
  name: 'pdf-additional-data',
  data() {
    return {
      pontosCim: '',
    };
  },
  mounted() {
    let qr = this.CreateQrCode('www.konasoft.hu');
    console.log(qr);
  },
  created() {},
  methods: {
    CreateQrCode(data) {
      var qr = qrcode(6, 'L');
      qr.addData(data);
      qr.make();
      return qr.createImgTag(4);
    },
    async GetPontosCim() {
      this.pontosCim = '';
      if (!this.mapSelected || !this.mapSelected.Latitude) {
        return;
      }
      try {
        // this.pontosCim = await apiService.GetPontosCim({
        //   lat: (this.mapSelected.Latitude + '').replace(/\./gi, ','),
        //   lon: (this.mapSelected.Longitude + '').replace(/\./gi, ','),
        // });
        // Meg kell várni ameddig a dom frissül
        await this.$nextTick();
        console.log(this.pontosCim);
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    ...mapGetters({}),
    currentDate() {
      let mapSelected = this.mapSelected;
      return new Date();
    },
    googleLink() {
      if (!this.mapSelected || !this.mapSelected.Latitude) {
        return null;
      }
      let url = `https://www.google.com/maps/search/?api=1&query=${this.mapSelected.Latitude},${this.mapSelected.Longitude}`;
      let qr = this.CreateQrCode(url);
      return { url, qr };
    },
    wazeLink() {
      if (!this.mapSelected || !this.mapSelected.Latitude) {
        return null;
      }
      let url = `https://www.waze.com/ul?ll=${this.mapSelected.Latitude}%2C${this.mapSelected.Longitude}`;
      let qr = this.CreateQrCode(url);
      return { url, qr };
    },
  },
  watch: {},
  props: {
    mapSelected: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
};
</script>
<style scoped>
.additional-data p,
.additional-data a {
  font-size: 16px !important;
}
.list-author-widget-contacts li span {
  min-width: 90px !important;
}
:not(.ikonok) i {
  color: #4db7fe;
}
</style>
